// extracted by css-extract-rspack-plugin
export default {"cls1":"SingleClaimPage-cls1_j2R","cls2":"SingleClaimPage-cls2_d_z SingleClaimPage-cls1_j2R"};